import { uniq } from "lodash-es";

import { FeatureFlag } from "./feature-flag.model";

export function getActiveDimensions(flags: Record<string, FeatureFlag<any>>): string[] {
	if (!flags) {
		return [];
	}
	return uniq(
		Object.entries(flags)
			.filter(([, flag]) => flag.enabled && flag.configDimension)
			.map(([, flag]) => (flag.configDimension as string).split(",").map((dimension) => dimension.trim()))
			.flat()
			.filter(Boolean)
	);
}
